import React from 'react';

import {
  useQuery,
  AccountClient,
  GET_INTEGRATIONS_BY_IDS
} from '@nile/graphql';
import envConfig from '@nile/home/src/Config/env';

const ActiveInvoiceBillingIntegrationIcon = ({
  integrationId,
  height = '26px',
  width = '26px'
}) => {
  const { loading, data: integrations, error } = useQuery(
    GET_INTEGRATIONS_BY_IDS,
    {
      client: AccountClient,
      variables: {
        integrationIds: ['QUICK_BOOKS_DESKTOP', 'QUICK_BOOKS_ONLINE', 'XERO']
      },
      skip: !!integrationId,
      fetchPolicy: 'network-only'
    }
  );

  const imageMap = {
    XERO: 'XeroBlue.svg',
    QUICK_BOOKS_ONLINE: 'QuickBooks.svg',
    QUICK_BOOKS_DESKTOP: 'QuickBooks.svg',
    QBO: 'QuickBooks.svg',
    QBD: 'QuickBooks.svg'
  };

  const activeIntegration =
    integrationId ||
    integrations?.getIntegrationsByIds?.find((el) => el.activated)
      ?.integrationId ||
    null;

  return activeIntegration && imageMap[activeIntegration] ? (
    <img
      height={height}
      width={width}
      src={`${envConfig.imageRoot}svg/${imageMap[activeIntegration]}`}
      alt=""
    />
  ) : null;
};

export default ActiveInvoiceBillingIntegrationIcon;
